export default {
  aliPayOauthToken: '/courier/api/financial/aliPayOauthToken'
}
